import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function Loading() {
  return (
    <div className="flex items-center justify-center">
      <FontAwesomeIcon
        icon={faSpinner}
        spin
        size="2x"
        className="text-blue-500"
      />
      <span className="ml-2 text-blue-500 font-semibold">Loading...</span>
    </div>
  );
}

export default Loading;
